export default __webpack_public_path__ + "static/media/2.6.9aab989c.mp3";